export default __webpack_public_path__ + "static/bed-bath-beyond-3-dd-e064105516086be197cac0d815a56a91.webp";